import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import useAnalytics from "../../hooks/useAnalytics";
import { getAdvisorByUuid } from "../../core/services/gutcheck-api.service";
import Loading from "../../components/Loading";

export const AdvisorRedirectPage = () => {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const uuid = searchParams.get('atuuid');
    const eventType = searchParams.get('atet');
    const { trackAdvisorEvent } = useAnalytics();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const handleRedirect = async () => {
            console.log("AdvisorRedirectPage: Starting redirect process", { uuid });
            
            // Determine the redirect path from the current URL
            // Remove /at from the beginning and get the rest of the path
            const currentPath = location.pathname;
            const redirectPath = currentPath.replace(/^\/at/, '');
            
            // Build new query parameters excluding 'atuuid'
            const newSearchParams = new URLSearchParams();
            searchParams.forEach((value, key) => {
                if (key !== 'atuuid' && key !== 'atet') {
                    newSearchParams.set(key, value);
                }
            });
            
            const redirectUrl = redirectPath + (newSearchParams.toString() ? `?${newSearchParams.toString()}` : '');
            
            console.log("AdvisorRedirectPage: Determined redirect URL", { 
                originalPath: currentPath,
                redirectPath,
                redirectUrl,
                preservedParams: newSearchParams.toString()
            });

            // If UUID is provided, try to fetch advisor and track event
            if (uuid) {
                try {
                    console.log("AdvisorRedirectPage: Fetching advisor data for UUID", { uuid });
                    
                    // Fetch advisor data by UUID
                    const { data, error: fetchError } = await getAdvisorByUuid(uuid);
                    
                    if (!fetchError && data?.advisor) {
                        const advisor = data.advisor;
                        console.log("AdvisorRedirectPage: Successfully fetched advisor", { 
                            advisorId: advisor.id, 
                            advisorUuid: advisor.uuid,
                            advisorName: advisor.name 
                        });

                        // Track the advisor event with the UUID
                        console.log("AdvisorRedirectPage: Tracking advisor event");
                        await trackAdvisorEvent(
                            advisor,
                            `Advisor - Click - ${eventType || redirectPath}`,
                            {
                                advisor_uuid: uuid,
                                original_url: window.location.href,
                                redirect_to: redirectUrl
                            }
                        );
                        console.log("AdvisorRedirectPage: Event tracked successfully");
                    } else {
                        console.warn("AdvisorRedirectPage: Advisor not found or fetch failed", { fetchError, data });
                        // Still redirect even if advisor not found
                    }
                } catch (err) {
                    console.error("AdvisorRedirectPage: Error fetching advisor or tracking event:", err);
                    // Still redirect even if there's an error
                }
            } else {
                console.warn("AdvisorRedirectPage: No UUID provided, redirecting without tracking");
            }

            console.log("AdvisorRedirectPage: Redirecting to", redirectUrl);
            
            // Always redirect to the determined URL
            navigate(redirectUrl, { replace: true });
        };

        handleRedirect();
    }, [uuid, trackAdvisorEvent, navigate, location.pathname, searchParams]);

    return <Loading />;
};